// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jJmh8UfdcYnvVSWshjCZ{display:flex;justify-content:start;align-items:center}`, "",{"version":3,"sources":["webpack://./src/app/common/components/rate.component/style.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,kBAAA","sourcesContent":[".app-rate-container {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-rate-container": `jJmh8UfdcYnvVSWshjCZ`
};
export default ___CSS_LOADER_EXPORT___;
